import { Dict, LocalizedValue } from '../../globalTypes'
import { DuckFootStepNameForAnalytics, DuckFootWizardOptions } from './DuckFoot/types'
import { ProcoteParamsType, ProcoteStepNameForAnalytics, ProcoteWizardOptions } from './Procote/types'

export enum ProductWizardType {
  DuckFoot = 'duck_foot',
  Procote = 'yara',
  Other = 'other',
}

export type WizardOptions = {
  multiplier?: string
  unit_name?: string
  url?: string
  product_id?: string
  description?: string
}

export type AnalyticsPageEventInfo = {
  step: ProcoteStepNameForAnalytics | DuckFootStepNameForAnalytics
}

export type AnalyticsTrackEventInfo = {
  step: ProcoteStepNameForAnalytics | DuckFootStepNameForAnalytics
  action?: string
  choice?: string
}

export type WizardData<Type extends ProductWizardType = ProductWizardType, IsSku extends boolean = any> = {
  type: Type
  steps: string[]
  params?: Dict<any>
  sku_params: Type extends ProductWizardType.Procote ? ProcoteParamsType<IsSku> : undefined
}

export interface ProductWizardNode<Type extends ProductWizardType = ProductWizardType> {
  children: ProductWizardNode[]
  created_at?: string
  id: string
  options: WizardOptions | null
  sku_options: (Type extends ProductWizardType.Procote ? ProcoteWizardOptions : DuckFootWizardOptions) | null
  parent_ids?: null | string[]
  title: string
  title_i18n: LocalizedValue<string>
  type: ProductWizardType
  updated_at?: string
  tags: {
    company_ids: string[]
    product_ids: string[]
  }
}

export type SubmitOptionsType<Type extends ProductWizardType = ProductWizardType, IsSku extends boolean = any> = {
  qty: number
  packaging: number | null
  seedTreatment?: string
  options?: string[]
  wizard_comment?: string
  wizard_data?: WizardData<Type, IsSku>
}

export type ProductWizardStepProps<Type extends ProductWizardType = ProductWizardType> = Omit<
  ProductWizardNode<Type>,
  'children'
>

export type AddCartItemParams<Type extends ProductWizardType = ProductWizardType, IsSku extends boolean = any> = {
  producer_id: string
  product_id: string
  quantity?: number
  packaging?: number | null
  seed_treatment_id?: string
  options?: string[]
  wizard_comment?: string
  wizard_data?: WizardData<Type, IsSku>
}

export type UpdateCartItemParams<
  Type extends ProductWizardType = ProductWizardType,
  IsSku extends boolean = any
> = Omit<AddCartItemParams<Type, IsSku>, 'producer_id' | 'product_id'>
